import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { Link, useLocation, useParams } from "react-router-dom";
import { fetchMyAppointments, fetchMyUserDetails, fetchWalletStatement, imageBaseUrl } from "../../constants/ApiConstants";
import { useSelector } from "react-redux";
import styled from "styled-components";

import toast from "react-hot-toast";
import axiosInstance from "../../utils/axiosInstance";
import { grey10, linearTopGradient } from "../../constants/colors";
import FullPageLoader from "../../components/FullPageLoader";
import PageHeader from "../../components/PageHeader";
import { IoAddCircle, IoRemoveCircle } from "react-icons/io5";
import LoadMore from "../../components/LoadMore";
import { convertToK, formatDateTimeToFullDatTime } from "../../utils/utils";
import AppointmentCard from "./AppointmentCard";

export default function PatientAppointments() {
  pageTitle("Patient Appointments");
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const userId = useSelector((state) => state.appSlice.userData?.id);
  const settings = useSelector((state) => state.appSlice.settings);
  const [start, setStart] = useState(0);
  const [appointments, setAppointments] = useState([]);
  const [showLoadMore, setShowLoadMore] = useState();

  const fetchAppointmentsFromServer = () => {
    setLoading(true);
    axiosInstance
      .post(fetchMyAppointments, { user_id: userId })
      .then((res) => {
        setAppointments(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAppointmentsFromServer();
  }, []);

  const tabs = ["All", "Upcoming", "Completed"];
  const [selectedTab, setSelectedTab] = useState("All");

  const getFilteredAppointments = () => {
    if (selectedTab === "All") {
      return [...appointments];
    }
    if (selectedTab === "Upcoming") {
      return [...appointments.filter((item) => item.status == 1)];
    }

    return [...appointments.filter((item) => item.status == 2)];
  };

  return (
    <>
      <Section topMd={60} topLg={100} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        {loading ? (
          <FullPageLoader />
        ) : (
          <Wrapper className="content-wrapper px-3">
            <PageHeader title="Appointments" />
            <div className="row mt-3">
              <div className="col-md-12">
                <div className="rounded px-3"></div>
                <div className="d-flex gap-2 mt-2 mb-2">
                  {tabs.map((tab) => (
                    <button onClick={() => setSelectedTab(tab)} key={tab} type="button" className={`text-sprimary px-4 py-1 rounded appTab ${tab === selectedTab ? "bg-primary2" : "bg-grey1"}`}>
                      <span className={`${selectedTab === tab ? "text-white" : "text-sprimary"} fs-normal`}>{tab}</span>
                    </button>
                  ))}
                </div>
                {!loading && appointments?.length === 0 && <strong className="d-block mt-5 mb-5 h-full w-full mx-auto text-gray text-center fs-md">No appointments available.</strong>}
                {!loading && appointments?.length > 0 && (
                  <div className="row pl-0 g-2 mt-3 gap-3">
                    {getFilteredAppointments().map((appointment) => (
                      <AppointmentCard appointmentData={appointment} />
                    ))}
                  </div>
                )}
                <LoadMore visible={showLoadMore} loading={loading} onLoadMoreClick={fetchWalletStatement} />
              </div>
            </div>
          </Wrapper>
        )}
      </Section>
    </>
  );
}

const Wrapper = styled.div`
  border-radius: 12px;
  button {
    outline: none;
    border: none;
  }
  @media screen and (min-width: 768px) {
  }
`;
